import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import PageWrapper from '../../components/PageWrapper';
import { 
    ButtonHeight, 
    RedirectDelay,
    PaymentType,
    PaymentTypeInfo,
    ContainerWidth,
    beautifyDate
} from '../../constants/appState';
import { 
    title_success,
    phrase_SuccessText,
    term_amount,
    term_points,
    term_merchant,
    term_details,
    term_payWith,
    term_refNum,
    term_date,
    term_cardDisplayName,
    phrase_continue,
    ErrorMessages
} from '../../constants/text';
import connectPage from '../../scenes/Main/index';
import Routes from '../../constants/routes';
import { appService } from '../../services';
import MessagePanel from '../../components/MessagePanel/index';


class Success extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.SUCCESS;
        this.goBackTimeout = null;

        this.state = {
            detailList: {
                [term_amount]: 0,
                [term_merchant]: '',
                [term_details]: '',
                [term_payWith]: '',
                [term_date]: '',
                [term_refNum]: '',
                [term_cardDisplayName]: '',
            },
            paymentSuccess: true,
            loyaltyIssuance: null
        }
    }

    componentDidMount() {
        const { mainProps } = this.props;
        const transactionData = mainProps.appState.transactionData;

        const paymentSuccess = transactionData.paymentStatus === "Authorised";
        if (paymentSuccess) {
            this.setState({
                detailList: {
                    [term_amount]: mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+transactionData.amount / 100),
                    [term_merchant]: transactionData.merchantInfo.name,
                    [term_details]: transactionData.displayDesc,
                    [term_payWith]: transactionData.payments,
                    [term_date]: beautifyDate(transactionData.authorisedDate),
                    [term_refNum]: transactionData.paymentRefNum,
                    [term_cardDisplayName]: transactionData.cardDisplayName,
                },
                paymentSuccess: paymentSuccess,
                loyaltyIssuance: transactionData.loyaltyIssuance
            });
        } else {
            this.setState({
                detailList: {
                    [term_amount]: mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(0),
                    [term_merchant]: transactionData.merchantInfo.name,
                    [term_details]: transactionData.displayDesc,
                    [term_refNum]: transactionData.paymentRefNum
                },
                paymentSuccess: paymentSuccess
            });
        }

        this.goBackTimeout = setTimeout(() => this.goBack(), RedirectDelay);
    }

    componentWillUnmount() {
        clearTimeout(this.goBackTimeout);
    }

    goBack = () => {
        const { mainProps } = this.props;
        const redirectUrl = (!!mainProps.appState.listenerData.redirectUrl && mainProps.appState.listenerData.redirectUrl !== '')
            ? mainProps.appState.listenerData.redirectUrl
            : mainProps.appState.transactionData.redirectUrl;

        window.location = redirectUrl;
    };

    goBackHome = () => {
        const { mainProps } = this.props;
        const { actionHandler } = this.props;

        const transactionData = mainProps.appState.transactionData;
        actionHandler.resetAllData();
        window.location = transactionData.redirectUrl;
    };

    doLoyaltyRegisterInit = () => {
        const { mainProps } = this.props;
        const transactionData = mainProps.appState.transactionData;

        appService.apiLoyaltyRegisterInit({
            paymentCode: window.PrestoPayObj.paymentCode,
            loyaltyType: 'BL',
            partnerRedirectUrl: encodeURIComponent(transactionData.redirectUrl),
            onSuccess: this.onLoyaltyRegisterInitSuccessHandler,
            onError: this.onLoyaltyRegisterInitFailedHandler
        });
    };

    onLoyaltyRegisterInitSuccessHandler = (resp) => {
        const { actionHandler } = this.props;

        if(!!resp.success) {

            actionHandler.resetAllData();
            window.location = resp.data.redirectUrl;
        } else {
            console.log("Fail for register init");
        }
    };

    onLoyaltyRegisterInitFailedHandler = (data) => {
        console.log("Error to register init");
    };

    htmlDecode = (input) => {
        const e = document.createElement('textarea');
        e.innerHTML = input;
        // handle case of empty input
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    };

    render() {
        const { mainProps } = this.props;
        const { detailList, paymentSuccess, loyaltyIssuance } = this.state;

        const transactionData = mainProps.appState.transactionData;

        const paymentList = detailList[term_payWith];

        let sortedPaymentList = [];
        if (paymentList !== undefined && paymentList !== '') {
            if (paymentList.length > 1) {
                // NOTE: get Wallet item
                let walletItem = paymentList.filter(item => (item.paymentMethod === PaymentType.PRESTOWALLET));

                // NOTE: get CashBack item
                let creditItem = paymentList.filter(item => (item.paymentMethod === PaymentType.CASHBACK));

                // NOTE: others
                let otherItems = paymentList.filter(item => (
                    item.paymentMethod !== PaymentType.PRESTOWALLET &&
                    item.paymentMethod !== PaymentType.CASHBACK)
                );

                sortedPaymentList = [...otherItems, ...walletItem, ...creditItem];
            } else {
                sortedPaymentList = paymentList;
            }
        }

        return (
            <React.Fragment>
                <PageWrapper>
                    <MessagePanel 
                        className={paymentSuccess ? "page-success" : "page-error"}
                        title={paymentSuccess ? title_success : ErrorMessages[transactionData.paymentStatus].title}
                        message={
						    paymentSuccess
						        ? phrase_SuccessText(detailList[term_amount], detailList[term_merchant])
						        : transactionData.errDesc
						          ? `${ErrorMessages[transactionData.paymentStatus].message}<br />(Reason: ${transactionData.errDesc})`
						          : ErrorMessages[transactionData.paymentStatus].message
						}
                        isError={!paymentSuccess}
                    >
                        <SuccessContentWrapper> 
                            <div className="transaction-details">
                                { Object.keys(detailList).map((key, index) => {
                                    if(key !== term_amount && key !== term_merchant && key !== term_cardDisplayName) {
                                        return (
                                            <DetailRow key={index} className="details-row">
                                                <div className="label">{key}</div>
                                                <div className="value">{
                                                    // (Array.isArray( detailList[key] ) ? (
                                                    ( key === term_payWith ? (
                                                        // NOTE: is payment list
                                                        sortedPaymentList.map((item, key) => {
                                                            return (
                                                                <div key={key}>{(
                                                                        (item.paymentMethod === PaymentType.CARD &&
                                                                            !!detailList[term_cardDisplayName] &&
                                                                            detailList[term_cardDisplayName] !== '' )
                                                                            ? detailList[term_cardDisplayName]
                                                                            : item.paymentMethodLabel !== null && item.paymentMethodLabel !== '' ? this.htmlDecode(item.paymentMethodLabel)
                                                                            : item.paymentMethod
                                                                    ) + ((item.points && item.points > 0) ? 
                                                                        '(' + item.points + ' ' + item.unit + ') (' +mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+item.amount / 100) + ')'
                                                                        : '(' + mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+item.amount / 100) + ')')
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    ) : detailList[key])
                                                }</div>
                                            </DetailRow>
                                        );
                                    }
                                })}
                            </div>
                        </SuccessContentWrapper>
                    </MessagePanel>
                </PageWrapper>
                { loyaltyIssuance && (
                    <IssuanceContentWrapper bgLogo={loyaltyIssuance.logo}>
                        <div className={loyaltyIssuance.issuanceState ? 'issuance-details' : 'issuance-details not-issued'}>
                            <div className={loyaltyIssuance.issuanceState ? 'icon': 'icon not-issued-icon'}>
                                {loyaltyIssuance.issuanceState && (
                                    <img src={loyaltyIssuance.logo} alt="Logo" />
                                )}
                            </div>
                            <div className="contents">
                                <div className="header">
                                    <div className="title">{loyaltyIssuance.title}</div>
                                    {loyaltyIssuance.issuanceState && (
                                        <div className="points">{'+' + loyaltyIssuance.points + ' Points'}</div>
                                    )}
                                </div>
                                <div className="details" dangerouslySetInnerHTML={{__html: loyaltyIssuance.details}}></div>
                            </div>
                            {loyaltyIssuance.issuanceState === false && (
                                <div onClick={this.doLoyaltyRegisterInit} className="link-account"></div>
                            )}
                        </div>
                    </IssuanceContentWrapper>
                    )
                }
                <SuccessActionWrapper>
                    <div className="action-area">
                                <PrestoAppComponents.Button 
                                    height={ButtonHeight+'px'}
                                    className="login-button"
                                    onClick={this.goBackHome}
                                >{phrase_continue(transactionData.merchantInfo.name)}</PrestoAppComponents.Button>
                            </div>
                </SuccessActionWrapper>
            </React.Fragment>
        );
    }
}

export default connectPage(Success);

const iconWidth = "3.0rem";

const DetailRow = styled.div`
    display: flex;
    padding: ${PrestoAppTheme.layout.commonGap} 0;
    border-bottom: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
    justify-content: space-between;

    &:last-child {
        border-bottom: 0;
    }

    & > .label { 
        width: 70px;
        font-wight: 300; 
        color: ${PrestoAppTheme.colors.baseGreyDark};
    }

    & > .value { 
        width: calc(100% - 70px);
        text-align: right;
        font-weight: 400; 
        word-break: break-word;
    }
`;

const SuccessContentWrapper = styled.div`
    & .transaction-details {
        padding: 0 ${PrestoAppTheme.layout.largeGap};
    }
`;

const IssuanceContentWrapper = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    max-width: ${ContainerWidth}px;
    margin: ${PrestoAppTheme.layout.commonGap} auto;
    box-shadow: ${PrestoAppTheme.layout.boxShadow};
    border-radius: ${PrestoAppTheme.layout.borderRadius};
    background-color: ${PrestoAppTheme.colors.white};
    overflow: hidden;

    & .issuance-details {
        padding: ${PrestoAppTheme.layout.commonGap} ${PrestoAppTheme.layout.largeGap};
        display: flex;
        flex-direction: row;
        align-items: center;

        & .icon { 
            height: ${iconWidth};
            width: ${iconWidth};
            margin-right: ${PrestoAppTheme.layout.xSmallGap};
            margin-left: -0.7rem;
            text-align: left;
        
            & > img {
                max-width: 100%;
                max-height: 100%;
                padding-top: 0.125rem;
                padding-bottom: 0.125rem;
            }
        }

        & .icon { 
            display: block;
        }

        & .not-issued-icon {
            width: 5rem;
        }

        & .contents { 
            font-weight: 400;
            margin-right: ${PrestoAppTheme.layout.xSmallGap};
            font-size: 0.75rem;
            line-height: 0.875rem;
            width: 100%;

            & .header {
                display: flex;
                flex-direction: row;
                font-weight: 500;
                padding: 0 0 ${PrestoAppTheme.layout.smallGap} 0;

                & .title { 
                    flex: 3;
                }

                & .points { 
                    flex: 1;
                    align-self: center;
                    text-align: end;
                    color: #00C597;
                }
            }
            
            & .details {

            }
            
        }

        & .link-account {
            border: solid black;
            border-width: 0 2px 2px 0;
            display: inline-block;
            padding: 2px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
        }

    }

    & .not-issued {
        background-image: url(${props => props.bgLogo || ''});
        background-color: #DAEDFD;
        background-repeat: no-repeat;
        background-size: contain;
    }
`;

const SuccessActionWrapper = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    max-width: ${ContainerWidth}px;
    margin: ${PrestoAppTheme.layout.commonGap} auto;

    & .action-area {
        padding: ${PrestoAppTheme.layout.commonGap} 0;
    }
`;